export default __webpack_public_path__ + "static/media/phone.4f3fc2a5.svg";